var map = {
	"./bash": 1749,
	"./java": 1750,
	"./json": 1751,
	"./julia": 1752,
	"./python": 1753,
	"./r": 1754,
	"./rust": 1755,
	"./scala": 1756,
	"./shell": 1757,
	"./sql": 1758,
	"./xml": 1759,
	"./yaml": 1760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1748;